<template>
  <div style="background-color:#304F64;">
    <div class="container">
      <div class="banner">
        <img src="../../assets/chaldal/laptop.png" alt="" />
        <div class="heading">
          <h2>JUMPSTART  YOUR ENGINEERING CAREER</h2>

            <a href="#chaldal" class="btn ">
              Apply Now
            </a>

        </div>
      </div>
      <div class="laptop-header text-center">
        <a href="#chaldal">
          <h1>
            Apply
          </h1>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
a{
  text-transform: capitalize;
  font-family: "Spartan";
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 0px;
  line-height: 24px;
  color:#181C2D;
}
.container {
  padding: 135px 0 100px 0;
}

.banner {
  position: relative;
  max-width: 820px;
  max-height: 548px;
  margin: 0 auto;
}
.banner img {
  width: 100%;
}
.heading {
  position: absolute;
  top: 10%;
  width: 100%;
  padding: 0 80px;
  text-align: center;
}
.heading h2 {
  text-transform: uppercase;
  font-family: "Spartan";
  font-size: 55px;
  font-weight: 800;
  letter-spacing: -1px;
  line-height: 70px;
  color: white;
}
.laptop-header h1 {
  text-transform: uppercase;
  font-family: "Spartan";
  font-size: 180px;
  font-weight: 800;
  letter-spacing: 0px;
  line-height: 64px;
  color: #a2d6f9;
  margin-top: -20px;
  padding-bottom: 100px;
}
.btn {
  margin: auto;
  position: absolute;

  top: 80;
  left: 0;
  bottom: 80;
  right: 0;

  width: 100%;

  background-color: #ffc600;
  text-align: center;
  max-width: 300px;
  height: 60px;
  border-radius: 0;
      padding-top: 15px;
}

@media only screen and (min-width: 601px) and (max-width: 1100px) {
  .heading h2 {
    font-size: 60px;
    font-weight: 800;
    letter-spacing: -3px;
    line-height: 60px;
    color: white;
  }
  .laptop-header h1 {
    text-transform: uppercase;
    font-family: "Spartan";
    font-size: 80px;
    font-weight: 800;
    letter-spacing: 0px;
    line-height: 64px;
    color: #a2d6f9;
    margin-top: -px;
    padding-bottom: 30px;
  }
  .btn {
    margin: auto;
    position: absolute;

    top: 80;
    left: 0;
    bottom: 80;
    right: 0;

    width: 100%;

    background-color: #ffc600;
    text-align: center;
    max-width: 200px;
    height: 60px;
    border-radius: 0;

  }
}
@media only screen and (max-width: 600px) {
  .container {
    padding: 65px 0 50px 0;
  }
  .heading h2 {
    font-size: 24px;
    font-weight: 800;
    letter-spacing: 0px;
    line-height: 24px;
    color: white;
  }
  .laptop-header h1 {
    font-size: 80px;
    font-weight: 800;
    letter-spacing: 0px;
    line-height: 64px;
    color: #a2d6f9;
    margin-top: -40px;
    padding-bottom: 30px;
  }
  .btn {
    margin: auto;
    position: absolute;

    top: 80;
    left: 0;
    bottom: 80;
    right: 0;

    width: 100%;

    background-color: #ffc600;
    text-align: center;
    max-width: 150px;
    height: 45px;
    border-radius: 0;
  }
}
</style>
